import type { AnonymousSettings, UploadSettings, SupportSettings } from "./settings.js";
import type { PublicMaintenance } from "./maintenance.js";

export const SUPPORTED_LOCALES = [
  "bg",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fi",
  "fr",
  "ga",
  "hr",
  "hu",
  "it",
  "lt",
  "lv",
  "mt",
  "nl",
  "pl",
  "pt",
  "ro",
  "sk",
  "sl",
  "sv",
] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_NATIVE_NAMES: Record<Locale, string> = {
  bg: "Български",
  cs: "Čeština",
  da: "Dansk",
  de: "Deutsch",
  el: "Ελληνικά",
  en: "English",
  es: "Español",
  et: "Eesti",
  fi: "Suomi",
  fr: "Français",
  ga: "Gaeilge",
  hr: "Hrvatski",
  hu: "Magyar",
  it: "Italiano",
  lt: "Lietuvių",
  lv: "Latviešu",
  mt: "Malti",
  nl: "Nederlands",
  pl: "Polski",
  pt: "Português",
  ro: "Română",
  sk: "Slovenčina",
  sl: "Slovenščina",
  sv: "Svenska",
};

export interface FooterLegalPage {
  slug: string;
  title: string;
  icon: string;
}

export interface PublicAppConfig {
  name: string;
  tagline: string;
  supportEmail: string;
  discordUrl: string | null;
  /** Lien d'invitation du bot Discord (permissions administrateur), ou `null`
   *  si l'identifiant d'application n'est pas configuré. */
  botInviteUrl: string | null;
  footerLegalPages: FooterLegalPage[];
  defaultLocale: Locale;
  supportedLocales: readonly Locale[];
  appUrl: string;
  settings: {
    anonymous: AnonymousSettings;
    upload: UploadSettings;
    support: SupportSettings;
  };
  maintenance: PublicMaintenance;
}
